/**
 * Ventora fan device action preparations (S4PB-0916176901).
 */

import {
	VENTORA_FAN_CLOUD_KEYS,
	VENTORA_FAN_SCENE_UI,
	ventoraFanOnUiToCloud,
	type VentoraFanRunMode,
} from 'src/components/Scenes/helpers/ventora_fan_scenes_helpers';
import type {
	DeviceActionContext,
	PreparedDeviceAction,
} from 'src/components/Scenes/helpers/device_actions/types';

/**
 * Prepares action payload for Ventora fan devices.
 * Writes `mode` / `on` / `speed` into a single `dev:{id}:setup` command.
 *
 * @param context - Context containing shared helpers and queued device actions.
 * @returns Prepared action payload ready for dispatch to the device.
 */
export const prepareFanAction = (context: DeviceActionContext): PreparedDeviceAction | undefined => {
	const { hexToDecimal, actions } = context;
	const modeAction = actions.find((action) => action.name === VENTORA_FAN_SCENE_UI.MODE);

	if (!modeAction?.value) {
		return undefined;
	}

	const runMode = modeAction.value as VentoraFanRunMode;
	const set: Record<string, unknown> = {
		_isdata: true,
		[VENTORA_FAN_CLOUD_KEYS.MODE]: runMode,
	};

	if (runMode === 'manual') {
		const onAction = actions.find((action) => action.name === VENTORA_FAN_SCENE_UI.ON);
		const speedAction = actions.find((action) => action.name === VENTORA_FAN_SCENE_UI.SPEED);

		if (onAction) {
			set[VENTORA_FAN_CLOUD_KEYS.ON] = ventoraFanOnUiToCloud(String(onAction.value));
		}

		if (speedAction) {
			set[VENTORA_FAN_CLOUD_KEYS.SPEED] = Number(speedAction.value);
		}
	}

	return {
		_gui_purpose: 'action',
		r: `dev:${hexToDecimal}:setup`,
		set,
	};
};
